"use client"

import { MotionConfig } from "framer-motion"

/**
 * Makes every framer-motion animation respect the user's OS "reduce motion"
 * setting (WCAG 2.3.3 / 2.2.2). `reducedMotion="user"` disables transform and
 * layout animations — the ones that cause vestibular discomfort — while leaving
 * opacity fades intact, so components still give feedback without moving.
 *
 * This is the JS-side counterpart to the `prefers-reduced-motion` reset in
 * globals.css (which only reaches CSS animations). Components that already call
 * `useReducedMotion()` themselves keep working — this just covers the ones that
 * don't, and anything added later, for free.
 */
export function ReducedMotionProvider({ children }: { children: React.ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>
}
